export const UPDATE_TAXONOMY = 'UPDATE_TAXONOMY';
export const GET_TAXONOMY = 'GET_TAXONOMY';
export const GET_TAXONOMYSCHEMA = 'GET_TAXONOMYSCHEMA';
export const ADD_TAXONOMY = 'ADD_TAXONOMY';
export const DELETE_TAXONOMY = 'DELETE_TAXONOMY';
export const LIST_TAXONOMIES = 'LIST_TAXONOMIES';
